"use client";

import React from 'react';
import Link from 'next/link';
import { ArrowLeft, Book, Flame } from 'lucide-react';
import { AboutLayout } from '@/components/about/about-layout';

const wandsCards = [
  { name: "Ace of Wands", slug: "ace-of-wands", turkish: "Değnekler Ası", keyword: "Yeni başlangıçlar", image: "ace-of-wands.svg" },
  { name: "Two of Wands", slug: "two-of-wands", turkish: "İki Değnek", keyword: "Planlama ve gelecek", image: "two-of-wands.svg" },
  { name: "Three of Wands", slug: "three-of-wands", turkish: "Üç Değnek", keyword: "Genişleme ve keşif", image: "three-of-wands.svg" },
  { name: "Four of Wands", slug: "four-of-wands", turkish: "Dört Değnek", keyword: "Kutlama ve istikrar", image: "four-of-wands.svg" },
  { name: "Five of Wands", slug: "five-of-wands", turkish: "Beş Değnek", keyword: "Çatışma ve rekabet", image: "five-of-wands.svg" },
  { name: "Six of Wands", slug: "six-of-wands", turkish: "Altı Değnek", keyword: "Zafer ve tanınma", image: "six-of-wands.svg" },
  { name: "Seven of Wands", slug: "seven-of-wands", turkish: "Yedi Değnek", keyword: "Savunma ve kararlılık", image: "seven-of-wands.svg" },
  { name: "Eight of Wands", slug: "eight-of-wands", turkish: "Sekiz Değnek", keyword: "Hız ve hareket", image: "eight-of-wands.svg" },
  { name: "Nine of Wands", slug: "nine-of-wands", turkish: "Dokuz Değnek", keyword: "Dayanıklılık ve sebat", image: "nine-of-wands.svg" },
  { name: "Ten of Wands", slug: "ten-of-wands", turkish: "On Değnek", keyword: "Yük ve sorumluluk", image: "ten-of-wands.svg" },
  { name: "Page of Wands", slug: "page-of-wands", turkish: "Değnekler Prensi", keyword: "Merak ve keşif", image: "page-of-wands.svg" },
  { name: "Knight of Wands", slug: "knight-of-wands", turkish: "Değnekler Şövalyesi", keyword: "Cesaret ve macera", image: "knight-of-wands.svg" },
  { name: "Queen of Wands", slug: "queen-of-wands", turkish: "Değnekler Kraliçesi", keyword: "Özgüven ve cazibe", image: "queen-of-wands.svg" },
  { name: "King of Wands", slug: "king-of-wands", turkish: "Değnekler Kralı", keyword: "Liderlik ve vizyon", image: "king-of-wands.svg" }
];

export default function WandsSuitPage() {
  return (
    <AboutLayout activeSection="tarot">
      <div className="max-w-6xl mx-auto px-4 py-8">
        {/* Current Section Indicator */}
        <div className="mb-4 p-3 bg-red-500/10 border border-red-500/20 rounded-lg">
          <div className="flex items-center gap-2 text-red-300">
            <Book className="h-4 w-4" />
            <span className="text-sm font-medium">🃏 Tarot</span>
            <span className="text-red-500">/</span>
            <span className="text-sm">Rider-Waite</span>
            <span className="text-red-500">/</span>
            <span className="text-sm">Minör Arkana</span>
            <span className="text-red-500">/</span>
            <span className="text-sm">Değnekler</span>
          </div>
        </div>

        {/* Breadcrumb */}
        <div className="mb-6">
          <Link
            href="/about"
            className="inline-flex items-center text-slate-400 hover:text-slate-200 transition-colors"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            AXTROLOG Nedir
          </Link>
          <span className="text-slate-500 mx-2">/</span>
          <Link
            href="/about/tarot/systems"
            className="text-slate-400 hover:text-slate-200 transition-colors"
          >
            Tarot Sistemleri
          </Link>
          <span className="text-slate-500 mx-2">/</span>
          <Link
            href="/about/tarot/systems/rider-waite"
            className="text-slate-400 hover:text-slate-200 transition-colors"
          >
            Rider-Waite
          </Link>
          <span className="text-slate-500 mx-2">/</span>
          <Link
            href="/about/tarot/systems/rider-waite/minor-arcana"
            className="text-slate-400 hover:text-slate-200 transition-colors"
          >
            Minör Arkana
          </Link>
          <span className="text-slate-500 mx-2">/</span>
          <span className="text-slate-300">Değnekler</span>
        </div>

        {/* Header */}
        <div className="bg-gradient-to-r from-red-900/20 to-orange-900/20 rounded-xl p-8 mb-8 border border-red-500/20">
          <h1 className="text-4xl font-bold text-slate-100 mb-4 flex items-center gap-3">
            <Flame className="h-10 w-10 text-red-400" />
            Değnekler (Wands) Suit'i
          </h1>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div>
              <p className="text-lg text-slate-200 leading-relaxed mb-4">
                Ateş elementi ile ilişkilendirilen Değnekler suit'i, yaratıcılık, tutku, enerji ve
                ruhsal güç alanlarını temsil eder. Girişimcilik, liderlik ve ilham konularında rehberlik sunar.
              </p>
              <div className="flex flex-wrap gap-2">
                <span className="px-3 py-1 bg-red-500/20 text-red-300 rounded-full text-sm">Ateş Elementi</span>
                <span className="px-3 py-1 bg-red-500/20 text-red-300 rounded-full text-sm">Yaratıcılık</span>
                <span className="px-3 py-1 bg-red-500/20 text-red-300 rounded-full text-sm">Tutku</span>
                <span className="px-3 py-1 bg-red-500/20 text-red-300 rounded-full text-sm">Liderlik</span>
              </div>
            </div>
            <div className="bg-slate-800/50 rounded-lg p-6 border border-red-500/30">
              <h3 className="text-lg font-semibold text-slate-100 mb-3">Temel Özellikler</h3>
              <ul className="space-y-2 text-slate-300 text-sm">
                <li>• <strong>Element:</strong> Ateş</li>
                <li>• <strong>Kişilik:</strong> Choleric (Sıcak ve Kuru)</li>
                <li>• <strong>Astrolojik İlişki:</strong> Koç, Aslan, Yay</li>
                <li>• <strong>Yaşam Alanı:</strong> Kariyer, yaratıcılık, ruhsal büyüme</li>
                <li>• <strong>Anahtar Kelimeler:</strong> Eylem, motivasyon, ilham</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mb-8">
          {wandsCards.map((card, index) => (
            <Link
              key={card.slug}
              href={`/about/tarot/systems/rider-waite/minor-arcana/wands/${card.slug}`}
              className="block"
            >
              <div className="bg-slate-800 rounded-xl p-6 border border-slate-700 hover:border-red-500/50 transition-all duration-300 cursor-pointer group shadow-lg hover:shadow-xl hover:scale-[1.02] h-full">
                <div className="text-center">
                  <div className="w-24 h-36 mx-auto mb-4 rounded-lg overflow-hidden group-hover:scale-105 transition-transform duration-300 shadow-lg">
                    <img
                      src={`/images/tarot/cards/${card.image}`}
                      alt={card.name}
                      className="w-full h-full object-cover"
                      onError={(e) => {
                        // Fallback to numbered circle if image fails to load
                        e.currentTarget.style.display = 'none';
                        const sibling = e.currentTarget.nextElementSibling as HTMLElement;
        if (sibling) {
          sibling.style.display = 'flex';
        }
                      }}
                    />
                    <div className="w-full h-full bg-gradient-to-br from-red-500 to-orange-700 rounded-lg flex items-center justify-center" style={{display: 'none'}}>
                      <span className="text-white font-bold text-lg">{index + 1}</span>
                    </div>
                  </div>
                  <h3 className="text-xl font-bold text-slate-100 mb-2">{card.name}</h3>
                  <p className="text-slate-400 text-sm mb-3">{card.turkish}</p>
                  <p className="text-red-400 text-sm font-medium">{card.keyword}</p>
                </div>
                <div className="mt-4 pt-4 border-t border-slate-700">
                  <span className="text-red-400 text-sm group-hover:translate-x-1 transition-transform duration-300 inline-block">
                    Kartı İncele →
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* Suit Information */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
          <div className="bg-slate-800 rounded-xl p-6 border border-slate-700">
            <h2 className="text-2xl font-semibold text-slate-100 mb-4">Değnekler Suit'inin Anlamı</h2>
            <div className="space-y-4">
              <div>
                <h3 className="text-lg font-semibold text-slate-100 mb-2">Pozitif Yönler</h3>
                <ul className="space-y-1 text-slate-300 text-sm">
                  <li>• Yaratıcı enerji ve ilham</li>
                  <li>• Liderlik ve girişimcilik</li>
                  <li>• Tutku ve motivasyon</li>
                  <li>• Hızlı eylem ve kararlılık</li>
                  <li>• Ruhsal büyüme ve gelişim</li>
                </ul>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-slate-100 mb-2">Dikkat Edilmesi Gerekenler</h3>
                <ul className="space-y-1 text-slate-300 text-sm">
                  <li>• Sabırsızlık ve aceleci davranışlar</li>
                  <li>• Aşırı hırs ve ego sorunları</li>
                  <li>• Dürtüsel kararlar</li>
                  <li>• Tükenmişlik ve enerji kaybı</li>
                  <li>• Çatışmacı yaklaşımlar</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="bg-slate-800 rounded-xl p-6 border border-slate-700">
            <h2 className="text-2xl font-semibold text-slate-100 mb-4">Yaşam Alanlarındaki Etkiler</h2>
            <div className="space-y-4">
              <div>
                <h3 className="text-lg font-semibold text-red-400 mb-2">Kariyer ve İş</h3>
                <p className="text-slate-300 text-sm leading-relaxed">
                  Girişimcilik projeleri, liderlik rolleri, yaratıcı çalışmalar ve hızlı gelişim gösteren iş alanları.
                </p>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-red-400 mb-2">İlişkiler</h3>
                <p className="text-slate-300 text-sm leading-relaxed">
                  Tutkulu romantik bağlantılar, yeni tanışmalar ve çekici kişilik özelliklerinin ön plana çıktığı dönemler.
                </p>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-red-400 mb-2">Kişisel Gelişim</h3>
                <p className="text-slate-300 text-sm leading-relaxed">
                  Ruhsal uyanış, yaratıcı yeteneklerin keşfi ve özgüven artışı süreçleri.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Element Connection */}
        <div className="bg-slate-800 rounded-xl p-6 border border-slate-700 mb-8">
          <h2 className="text-2xl font-semibold text-slate-100 mb-6">Ateş Elementi Bağlantısı</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-red-500 to-orange-700 rounded-full flex items-center justify-center mx-auto mb-4">
                <Flame className="h-8 w-8 text-white" />
              </div>
              <h3 className="font-semibold text-slate-200 mb-2">Enerji</h3>
              <p className="text-slate-400 text-sm">Yüksek titreşim, hareket ve dinamizm</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-yellow-500 to-red-700 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white text-2xl">⚡</span>
              </div>
              <h3 className="font-semibold text-slate-200 mb-2">İlham</h3>
              <p className="text-slate-400 text-sm">Divine kıvılcım ve yaratıcı akış</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-red-700 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white text-2xl">🎯</span>
              </div>
              <h3 className="font-semibold text-slate-200 mb-2">Eylem</h3>
              <p className="text-slate-400 text-sm">Hedefe yönelik kararlı adımlar</p>
            </div>
          </div>
        </div>

        {/* Important Note */}
        <div className="bg-amber-900/20 border border-amber-700/50 rounded-xl p-6 mb-8">
          <h3 className="text-lg font-semibold text-amber-200 mb-3">⚠️ Önemli Uyarı</h3>
          <p className="text-amber-100 leading-relaxed">
            Tarot kartları sembolik yorumlama araçlarıdır ve kesinlik iddiası taşımazlar. İçerikler tamamen
            merak, eğlence ve kişisel farkındalık amaçlıdır. Yaşamsal kararlar için uzman görüşü alınmalıdır.
          </p>
        </div>

        {/* Navigation */}
        <div className="flex justify-between items-center">
          <Link
            href="/about/tarot/systems/rider-waite/minor-arcana"
            className="inline-flex items-center px-4 py-2 bg-slate-800 hover:bg-slate-700 border border-slate-600 rounded-lg text-slate-300 hover:text-slate-100 transition-colors"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Minör Arkana
          </Link>

          <Link
            href="/about/tarot/systems/rider-waite/minor-arcana/cups"
            className="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors"
          >
            Kupalar
            <ArrowLeft className="h-4 w-4 ml-2 rotate-180" />
          </Link>
        </div>
      </div>
    </AboutLayout>
  );
}